import React from "react";
import { IconSearch } from "@tabler/icons-react";
import { SEARCH_PLACEHOLDER } from "../utils/jobsConstants";

/** Search input for filtering roles by title. */
const SearchBar = ({ value, onChange }) => {
  return (
    <div className="jobsSearchBar">
      <IconSearch className="jobsSearchIcon" size={20} stroke={1.75} />
      <input
        type="text"
        className="jobsSearchInput"
        placeholder={SEARCH_PLACEHOLDER}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label="Search roles"
      />
    </div>
  );
};

export default SearchBar;
